import React, { Fragment } from "react";
import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";
import img13 from "../../../images/service/webapp/website & portals.png";
import ServiceHero from "../components/ServiceHero";
import ServiceJourney from "../components/ServiceJourney";
import ServiceCapabilities from "../components/ServiceCapabilities";
import ServiceResults from "../components/ServiceResults";
import ServiceOutcomes from "../components/ServiceOutcomes";
import ServiceWhyChooseUs from "../components/ServiceWhyChooseUs";
import FaqSection from "../../../components/PageSection/FAQsection";

const WebsitePortals = () => {
  const heroData = {
    title: "Professional Website & Portal Development",
    description: "Transform your digital presence with custom websites and portals that combine stunning design with powerful functionality. We create platforms that engage users, streamline operations, and drive measurable business results.",
    image: img13,
    imageAlt: "Website and Portals",
    features: [
      "Modern responsive design",
      "User-centered architecture",
      "Seamless integrations",
      "Performance optimized",
      "Secure & scalable",
      "Easy content management",
    ],
    pillars: [
      "User experience that delights and converts visitors",
      "Robust architecture that ensures reliability and scalability",
      "Strategic functionality that supports your business goals",
    ],
  };

  const journeySteps = [
    {
      title: "Discovery & Planning",
      description: "We analyze your business requirements, target audience, and goals to create a comprehensive website and portal strategy.",
      details: ["Business analysis", "Audience research", "Competitor review", "Information architecture", "Feature planning", "Success metrics"],
    },
    {
      title: "Design & Prototyping",
      description: "Our design team creates engaging interfaces with intuitive navigation and beautiful layouts that reflect your brand identity.",
      details: ["Brand alignment", "Wireframe design", "Visual mockups", "Responsive layouts", "Interactive prototypes", "User testing"],
    },
    {
      title: "Development & Integration",
      description: "We build robust websites and portals with modern frameworks, ensuring seamless integration with your existing systems and tools.",
      details: ["Frontend development", "Backend systems", "CMS integration", "API connections", "Third-party tools", "Security implementation"],
    },
    {
      title: "Launch & Optimization",
      description: "Comprehensive testing, performance optimization, SEO setup, and successful launch with ongoing support and improvements.",
      details: ["Quality assurance", "Performance tuning", "SEO optimization", "Content migration", "Launch execution", "Continuous support"],
    },
  ];

  const capabilities = [
    {
      title: "Corporate Websites",
      content:
        "Professional corporate websites that establish your brand presence, showcase your services, and drive business growth with modern design and functionality.",
    },
    {
      title: "Customer Portals",
      content:
        "Secure, user-friendly customer portals that enhance engagement, streamline support, and provide self-service capabilities for your clients.",
    },
    {
      title: "Employee Portals",
      content:
        "Internal portals that centralize resources, improve communication, and boost productivity with intuitive interfaces and seamless integrations.",
    },
    {
      title: "Community Portals",
      content:
        "Engaging community platforms that foster collaboration, knowledge sharing, and member interaction with powerful social features.",
    },
  ];

  const resultsData = {
    metrics: [
      { value: "+85%", label: "User engagement increase" },
      { value: "92+", label: "Average performance score" },
      { value: "3–6×", label: "ROI within first year" },
    ],
    description: "We deliver measurable improvements in user engagement, conversion rates, and overall business performance through strategic website and portal development.",
  };

  const outcomesData = {
    description: "We create powerful digital platforms that combine beautiful design with robust functionality, delivering exceptional user experiences and measurable business results.",
    outcomes: [
      "Responsive design that works flawlessly across all devices",
      "SEO-optimized structure for better search engine visibility",
      "Fast loading times with performance optimization",
      "Intuitive navigation and user-friendly interfaces",
      "Secure authentication and data protection",
      "Easy content management and updates",
    ],
  };

  const whyChooseUs = [
    {
      title: "Custom Solutions",
      content:
        "Every website and portal we build is tailored to your specific needs, ensuring it perfectly aligns with your business objectives and user expectations.",
    },
    {
      title: "Scalable Architecture",
      content:
        "We design platforms that grow with your business, handling increased traffic and functionality without compromising performance.",
    },
    {
      title: "Security First",
      content:
        "Built-in security measures protect your data and users, with compliance to industry standards and best practices.",
    },
    {
      title: "Ongoing Support",
      content:
        "From launch to growth, our team provides continuous support, maintenance, and optimization to keep your platform running smoothly.",
    },
  ];

  const faqs = [
    {
      q: "What's the difference between a website and a portal?",
      a: "A website is typically informational and public-facing, while a portal is an authenticated platform with personalized content, user accounts, and interactive features for specific user groups.",
    },
    {
      q: "How long does it take to develop a custom portal?",
      a: "Basic portals take 8-12 weeks, while complex enterprise portals with integrations may take 4-6 months. Timeline depends on features, user roles, integrations, and customization requirements.",
    },
    {
      q: "Can you redesign our existing website while keeping our content?",
      a: "Yes! We can completely redesign your website with modern design and improved functionality while preserving your existing content, SEO rankings, and migrating everything seamlessly.",
    },
    {
      q: "Will my website be mobile-friendly and SEO optimized?",
      a: "Absolutely. All our websites and portals are fully responsive, mobile-optimized, and built with SEO best practices including fast loading times, schema markup, and proper meta tags for better search rankings.",
    },
  ];

  return (
    <Fragment>
      <div className="br-app">
        <div id="page" className="page">
          <Header />
          <PageTitle
            pageTitle={"Website and Portals"}
            pagesub={"Web & App Development"}
          />
          <main className="page_content service-detials">
            <section className="pt-130 pb-130 gray-bg">
              <div className="container">
                <ServiceHero {...heroData} />
                <ServiceJourney title="Our Website & Portal Creation Journey" steps={journeySteps} />
                <ServiceCapabilities capabilities={capabilities} />
                <ServiceResults {...resultsData} />
                <ServiceOutcomes {...outcomesData} />
                <ServiceWhyChooseUs items={whyChooseUs} />
                <FaqSection faqs={faqs} />
              </div>
            </section>
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default WebsitePortals;
